import styled from "@emotion/styled";
import { Swiper, SwiperSlide } from "swiper/react";
import BaseButton from "src/atoms/Button/BaseButton";

const StyledThumbnailContainer = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    display: block;
    height: 100%;
  }
`;

const StyledSwiper = styled(Swiper)<{ isclient?: string }>`
  height: 624px;
  width: 80px;

  ${({ isclient }) =>
    !isclient &&
    `.swiper-wrapper {
      overflow: auto;
      flex-direction: column;
    };

    .swiper-slide {
      height: 122px;
    }

  }`}
`;

const StyledSwiperSlide = styled(SwiperSlide)`
  box-sizing: border-box;
  cursor: pointer;
  border: none;
  background: none;
`;
// The SwiperSlide component needs 'SwiperSlide' as the displayName, otherwise Swiper won't pick up the slides
StyledSwiperSlide.displayName = "SwiperSlide";

const StyledButtonNext = styled(BaseButton)<{ shouldHide: boolean }>`
  display: ${({ shouldHide }) => (shouldHide ? "none" : "initial")};
  position: absolute;
  border: none;
  background: none;
  cursor: pointer;
  left: 18px;

  svg {
    fill: ${({ theme }) => theme.colors.tone.anthraciteLight};
    width: 40px;
  }
`;

const StyledButtonBack = styled(StyledButtonNext)`
  top: -${({ theme }) => theme.space[4]}px;

  svg {
    transform: rotate(180deg);
  }
`;

export {
  StyledThumbnailContainer,
  StyledButtonBack,
  StyledButtonNext,
  StyledSwiper,
  StyledSwiperSlide,
};
